module.exports = __webpack_public_path__ + "img/8-small.5649241e.png";